<template>
  <footer class="">
    <nav class="navbar navbar-expand-sm   ">
      <div class="container-xl footer-block">
        <div class="collapse d-none d-lg-flex" id="navbarCollapse">
          <ul class="navbar-nav mr-auto d-none d-lg-flex">
            <li class="nav-item">
              <a class="nav-link" href="#/"><strong>Главная</strong></a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#/rules"><strong>Условия использования</strong></a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#/about-service"><strong>Описание</strong></a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#/help"><strong>Помощь</strong></a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#/contactUs"><strong>Контакты</strong></a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </footer>
</template>

<script>
export default {
  name: 'FooterBottom'
}
</script>

<style scoped>

.navbar-bg{
  background:#07ACE3;
}
.main-logo{
  cursor:pointer;
}
</style>
